import axios from 'axios';
import { GET_VENTES, GET_VENTES_BY_USER, GET_VENTES_BY_CHARGE, GET_SPECIFIC_VENTE, CLEAR_SPECIFIC_VENTE, ADD_VENTE, DELETE_VENTE, VENTES_LOADING, CLEAR_VENTES, BIEN_VENDU, UPLOAD_CONTRAT_SIGNE, DO_DT, EDIT_VENTE_CHARGE, EDIT_VENTE_COMMISSIONED_TO, EDIT_VENTE_PROMOTEUR, EDIT_VENTE_BIEN_PRICE, EDIT_VENTE } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IBien, ITableClientLine, IEncaissementLine, IAssociation, IVente, IClient, ISociete } from '../../types/interfaces';
import store from '../store';

export const getVentes = (duration: any, excludeAssociations: number, projectId: number | "ALL", projectName: string, possibleProjets: ISociete[]) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: VENTES_LOADING
  });
  axios
    .get('/api/ventes', {...tokenConfig(getState), params: {duration, excludeAssociations, projectId, projectName, possibleProjets}})
    .then(res =>
      dispatch({
        type: GET_VENTES,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getVentesByIdsPromise = async (ids: number[]) : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/ventes/byIds', {...tokenConfig(store.getState), params: {ids}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
    });
  });
};

export const getClientVentes = async (duration: any, excludeAssociations: number, projectId: number | "ALL", projectName: string, possibleProjets: ISociete[]) : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/ventes/clients', {...tokenConfig(store.getState), params: {duration, excludeAssociations, projectId, projectName, possibleProjets}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getClientVentes", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    });
  });
};

export const getLastNumDossier = async (projectId: number, type: string) : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/ventes/lastNumDossier', {...tokenConfig(store.getState), params: {projectId, type}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getLastNumDossier", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    });
  });
};

export const getVentesByUser = (duration: any, userIds: number[], excludeAssociations: number, projectId: number, projectName: string, possibleProjets: ISociete[], titled: string = "ALL", byCommissionTo: number = 0) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: VENTES_LOADING
  });
  axios
    .get('/api/ventes/byUser', {...tokenConfig(getState), params: {duration, userIds, excludeAssociations, projectId, projectName, possibleProjets, titled, byCommissionTo}})
    .then(res =>
      dispatch({
        type: GET_VENTES_BY_USER,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getVentesByCharge = (duration: any, userIds: number[], includeNocharges: number, titled: string, signeNotaireOnly: number, excludeAssociations: number, projectId: number, projectName: string, possibleProjets: ISociete[]) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: VENTES_LOADING
  });
  axios
    .get('/api/ventes/byCharge', {...tokenConfig(getState), params: {duration, userIds, includeNocharges, titled, signeNotaireOnly, excludeAssociations, projectId, projectName, possibleProjets}})
    .then(res =>
      dispatch({
        type: GET_VENTES_BY_CHARGE,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getVentesByChargePP = (duration: any, userIds: number[], includeNocharges: number, titled: string, excludeAssociations: number, projectId: number, projectName: string, possibleProjets: ISociete[]) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: VENTES_LOADING
  });
  axios
    .get('/api/ventes/byChargePP', {...tokenConfig(getState), params: {duration, userIds, includeNocharges, titled, excludeAssociations, projectId, projectName, possibleProjets}})
    .then(res =>
      dispatch({
        type: GET_VENTES_BY_CHARGE,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getSummaryProject = (duration: any, userIds: number[], includeNocharges: number, titled: string, excludeAssociations: number, possibleProjets: ISociete[]) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: VENTES_LOADING
  });
  axios
    .get('/api/ventes/summaryProject', {...tokenConfig(getState), params: {duration, userIds, includeNocharges, titled, excludeAssociations, possibleProjets}})
    .then(res =>
      dispatch({
        type: GET_VENTES_BY_CHARGE,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getSummaryProjectBudget0 = (titled: string, excludeAssociations: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: VENTES_LOADING
  });
  axios
    .get('/api/ventes/summaryProjectBudget', {...tokenConfig(getState), params: {titled, excludeAssociations}})
    .then(res =>
      dispatch({
        type: GET_VENTES_BY_CHARGE,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getSummaryProjectBudget = (excludeAssociations: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: VENTES_LOADING
  });
  axios
    .get('/api/ventes/summaryProjectBudget', {...tokenConfig(getState), params: {excludeAssociations}})
    .then(res =>
      dispatch({
        type: GET_VENTES_BY_CHARGE,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getLivraisonsForCommission = async (duration: any, userIds: number[], projectId: number, projectName: string, possibleProjets: ISociete[], titled: string = "ALL") : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/ventes/livraisonForCommission', {...tokenConfig(store.getState), params: {duration, userIds, projectId, projectName, possibleProjets, titled}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getLivraisonsForCommission", err)
    });
  });
};

export const getVentesByNumDossier = async (num_dossier: string, projectId: number) : Promise<IVente[]> => {
  return new Promise((resolve) => {
  axios
    .get('/api/ventes/byNumDossier', {...tokenConfig(store.getState), params: {num_dossier, projectId}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err =>
      console.log("err getVentesByNumDossier", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    );
  });
};

export const getVenteIDFromID = async (ID: number, projectId: number) : Promise<number | boolean> => {
  return new Promise((resolve) => {
  axios
    .get('/api/ventes/byID', {...tokenConfig(store.getState), params: {ID, projectId}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getVenteIDFromID", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    });
  });
};

export const getVenteIDFromBienID = async (bienID: number, projectId: number) : Promise<number | boolean> => {
  return new Promise((resolve) => {
  axios
    .get('/api/ventes/byBienID', {...tokenConfig(store.getState), params: {bienID, projectId}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getVenteIDFromBienID", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    });
  });
};

export const getVentesByCIN = async (CIN: string, projectId: number) : Promise<IVente[]> => {
  return new Promise((resolve) => {
  axios
    .get('/api/ventes/byCIN', {...tokenConfig(store.getState), params: {CIN, projectId}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err =>
      console.log("err getVentesByCIN", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    );
  });
};

export const getVentesByEnc = async (refReglement: string, projectId: number) : Promise<IVente[]> => {
  return new Promise((resolve) => {
  axios
    .get('/api/ventes/byEnc', {...tokenConfig(store.getState), params: {refReglement, projectId}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err =>
      console.log("err getVentesByCIN", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    );
  });
};

export const getVenteById = (id: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: VENTES_LOADING
  });
  axios
    .get('/api/ventes/specific', {...tokenConfig(getState), params: {id}})
    .then(res =>
      dispatch({
        type: GET_SPECIFIC_VENTE,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getVenteByIdPromise = async (id: number, specialAccess: number = 0): Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/ventes/specific', {...tokenConfig(store.getState), params: {id, specialAccess}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getVenteByIdPromise", err)
    });
  });
};

export const getCustomizedVentePromise = async (desistementId: any, isPart: number = 0): Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/ventes/customized', {...tokenConfig(store.getState), params: {desistementId, isPart}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getVenteByIdPromise", err)
    });
  });
};

export const getAssociationByIdPromise = async (id: number): Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/ventes/specificAssociation', {...tokenConfig(store.getState), params: {id}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getAssociationByIdPromise", err)
    });
  });
};

export const getRecuImages = async (venteId: number): Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/ventes/recu_images', {...tokenConfig(store.getState), params: {venteId}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getRecuImages", err)
    });
  });
};

export const addVente = (isAssociation: number, bien: IBien, contrat: IVente | undefined, clients: /*ITableClientLine*/IClient[], encaissements: IEncaissementLine[]/*, recuFile: any*/, recu_image_counter: number, uploads: any[], association: IAssociation | undefined, projetID: number, projet: string, numDossier: string, dateVente: Date, netMPrice: number, netPrice: number, observation: string, userId: number | undefined, userName: string | undefined, comId: number, comName: string, remise: number, prixAafficher: number, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/ventes', {isAssociation, bien, contrat, clients, encaissements/*, recuFile*/, recu_image_counter, uploads, association, projetID, projet, numDossier, dateVente, netMPrice, netPrice, observation, userId, userName, comId, comName, remise, prixAafficher }, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: ADD_VENTE,
        payload: res.data
      })
      dispatch({
        type: BIEN_VENDU,
        payload: res.data
      })
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(err?.response ? {err: err.response.data} : false)
    });
};

export const editVenteCharge = (id: number, isAssociation: boolean, chargeId: number, chargeName: string, userId: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post(isAssociation ? '/api/ventes/editChargeAssociation' : '/api/ventes/editCharge', {id, chargeId, chargeName, userId}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_VENTE_CHARGE,
        payload: res.data
      })
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(err?.response ? {err: err.response.data} : false)
    });
};

export const editVenteCommissionedTo = (id: number, isAssociation: boolean, comId: number, comName: string, userId: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post(isAssociation ? '/api/ventes/editCommissionedToAssociation' : '/api/ventes/editCommissionedTo', {id, comId, comName, userId}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_VENTE_COMMISSIONED_TO,
        payload: res.data
      })
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(err?.response ? {err: err.response.data} : false)
    });
};

export const editVentePromoteur = (id: number, promoteurId: number, promoteurName: string, userId: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/ventes/editPromoteur', {id, promoteurId, promoteurName, userId}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_VENTE_PROMOTEUR,
        payload: res.data
      })
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(err?.response ? {err: err.response.data} : false)
    });
};

export const editVenteMinuteComment = (id: number, comment: string, userId: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/ventes/editMinuteComment', {id, comment, userId}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_VENTE,
        payload: res.data
      })
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(err?.response ? {err: err.response.data} : false)
    });
};

export const editBienPrice = (bienId: number, venteId: number | undefined, changeVente: number, changeBien: number, prix: number, prixM: number, prixBien: number, prixBienM: number, remise: number, prixMin: number, prixMinM: number, comment: string, userId: number | undefined, upload: any, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/ventes/editBienPrice', {bienId, venteId, changeVente, changeBien, prix, prixM, prixBien, prixBienM, remise, prixMin, prixMinM, comment, userId, upload}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_VENTE_BIEN_PRICE,
        payload: res.data
      })
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(err?.response ? {err: err.response.data} : false)
    });
};

export const editVente = (venteId: number, notaireId: number | null, chezNotaire: number, chezNotaireDate: Date | null, signatureEnCours: number, enCoursDate: Date | null, signeNotaire: number, notaireDate: Date | null, expeditionDate: Date | null, minuteDate: Date | null, by_user_id: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/ventes/edit', {venteId, notaireId, chezNotaire, chezNotaireDate, signatureEnCours, enCoursDate, signeNotaire, notaireDate, expeditionDate, minuteDate, by_user_id}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_VENTE,
        payload: res.data
      })
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(err?.response ? {err: err.response.data} : false)
    });
};

export const doDT = (vente1ID: number | undefined, vente2ID: number | undefined, association1ID: number | undefined, association2ID: number | undefined, vente1: any, vente2: any, association1: any, association2: any, isAssociation1: number, isAssociation2: number, duplicateClient1: number, duplicateClient2: number, totalWithdraw1: number, totalWithdraw2: number, transferToNew1: number, transferToNew2: number, changeBien1: number, changeBien2: number, selectedBien1: any, selectedBien2: any, isAssociationBien1: number, isAssociationBien2: number, selectedAssociation1: any, selectedAssociation2: any, desistementsClients1: any[], desistementsClients2: any[], desistementsPClients1: any[], desistementsPClients2: any[], addedClients1: any[], addedClients2: any[], desistementsEncaissements1: any[], desistementsEncaissements2: any[], transfertsClients1: any[], transfertsClients2: any[], transfertsEncaissements1: any[], transfertsEncaissements2: any[], comment1: string, comment2: string, userId: number | undefined, userName: string | undefined, uploads: any[], callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/ventes/doDT', {vente1ID, vente2ID, association1ID, association2ID, vente1, vente2, association1, association2, isAssociation1, isAssociation2, duplicateClient1, duplicateClient2, totalWithdraw1, totalWithdraw2, transferToNew1, transferToNew2, changeBien1, changeBien2, selectedBien1, selectedBien2, isAssociationBien1, isAssociationBien2, selectedAssociation1, selectedAssociation2, desistementsClients1, desistementsClients2, desistementsPClients1, desistementsPClients2, addedClients1, addedClients2, desistementsEncaissements1, desistementsEncaissements2, transfertsClients1, transfertsClients2, transfertsEncaissements1, transfertsEncaissements2, comment1, comment2, userId, userName, uploads }, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: DO_DT,
        payload: res.data
      })
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(err?.response ? {err: err.response.data} : false)
    });
};

export const undoDesistementGroup = async (desistementId: number) : Promise<boolean> => {
  return new Promise((resolve) => {
    axios
      .post('/api/ventes/undoDesistementGroup', {desistementId}, tokenConfig(store.getState))
      .then(res => {
        resolve(true)
      })
      .catch(err => {
        resolve(false);
        console.log("err undoDesistementGroup", err)
      });
  });
};

export const undoDesistementClient = async (desistementId: number) : Promise<boolean> => {
  return new Promise((resolve) => {
    axios
      .post('/api/ventes/undoDesistementClient', {desistementId}, tokenConfig(store.getState))
      .then(res => {
        resolve(true)
      })
      .catch(err => {
        resolve(false);
        console.log("err undoDesistementClient", err)
      });
  });
};

export const undoDesistementEncaissement = async (desistementId: number) : Promise<boolean> => {
  return new Promise((resolve) => {
    axios
      .post('/api/ventes/undoDesistementEncaissement', {desistementId}, tokenConfig(store.getState))
      .then(res => {
        resolve(true)
      })
      .catch(err => {
        resolve(false);
        console.log("err undoDesistementEncaissement", err)
      });
  });
};

export const addContratSigne = (venteID: number, username: string | undefined, upload: any, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/ventes/signed', { venteID, username, upload }, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPLOAD_CONTRAT_SIGNE,
        payload: res.data
      })
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 488))
      callback(false)
    });
};

export const uploadToFTP = async (file: any) : Promise<boolean> => {
  return new Promise((resolve) => {
  axios
    .post('/api/ventes/uploadToFTP', { file })
    .then(res =>
      resolve(true)
    )
    .catch(err => {
      resolve(false);
      console.log("err uploadToFTP", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    });
  });
};

export const createPlaceholderDrive = (recuId: number | null, isNewRecu: number, recu_image_counter: number, recutype: string, venteId: number, bienId: number, isAssociation: number, associationId: number | null, remise_state: number, from_dr: number, userId: number | undefined) : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .post('/api/ventes/createPlaceholderDrive', { recuId, isNewRecu, recu_image_counter, recutype, venteId, bienId, isAssociation, associationId, remise_state, from_dr, userId }, tokenConfig(store.getState))
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      resolve(false);
      console.log("err createPlaceholderDrive", err)
    });
  });
};

export const replaceRecu = (recuId: number, isNewRecu: number, recu_image_counter: number, recutype: string, venteId: number, bienId: number, isAssociation: number, associationId: number, VCs: number[], VEs: number[], file: any, driveFileId: string, driveUrl: string, userId: number | undefined/*, userName: string | undefined*/) : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .post('/api/ventes/replaceRecu', { recuId, isNewRecu, recu_image_counter, recutype, venteId, bienId, isAssociation, associationId, VCs, VEs, file, driveFileId, driveUrl, userId }, tokenConfig(store.getState))
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      resolve(false);
      console.log("err replaceRecu", err)
    });
  });
};

export const uploadRecuAfterVente = (recuId: number, venteId: number, recuFile: any, driveFileId: string) : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .post('/api/ventes/uploadRecuAfterVente', { recuId, venteId, recuFile, driveFileId }, tokenConfig(store.getState))
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      resolve(false);
      console.log("err uploadRecuAfterVente", err)
    });
  });
};

export const uploadToFTP0 = (file: any, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/ventes/uploadToFTP', { file }, tokenConfig(getState))
    .then(res => {
      // dispatch({
      //   type: UPLOAD_RECU,
      //   payload: res.data
      // })
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const editComVentePromise = async (id: number, comId: number) : Promise<boolean> => {
  return new Promise((resolve) => {
    axios
      .post('/api/ventes/editCom', {id,comId}, tokenConfig(store.getState))
      .then(res => {
        resolve(true)
      })
      .catch(err => {
        resolve(false);
        console.log("err editComVentePromise", err)
      });
  });
};

export const venteAssToUniquePromise = async (venteId: number) : Promise<boolean> => {
  return new Promise((resolve) => {
    axios
      .post('/api/ventes/assToUnique', {venteId}, tokenConfig(store.getState))
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        resolve(false);
        console.log("err venteAssToUniquePromise", err)
      });
  });
};

export const deleteVente = (id: number) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/ventes/${id}`, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: DELETE_VENTE,
        payload: id
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const deleteVentePromise = async (id: number) : Promise<boolean> => {
  return new Promise((resolve) => {
    axios
      .delete(`/api/ventes/${id}`, tokenConfig(store.getState))
      .then(res => {
        resolve(true)
      })
      .catch(err => {
        resolve(false);
        console.log("err deleteVentePromise", err)
      });
  });
};

export const setVentesLoading = () => {
  return {
    type: VENTES_LOADING
  };
};

export const clearVentes = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_VENTES
  })
};

export const clearVenteCard = () => (dispatch: Function) => {
  dispatch({
    type: CLEAR_SPECIFIC_VENTE
  });
};

